export class EmailPasswordCredentials {
    email: string;
    password: string;
  }


// WEBPACK FOOTER //
// /app/src/app/core/models/email-password-credentials.ts